import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DeferredFragmentIdentifierClass;
function DeferredFragmentIdentifier() {
  if (DeferredFragmentIdentifierClass === VOID) {
    class $ {
      constructor(path, label) {
        this.p46_1 = path;
        this.q46_1 = label;
      }
      toString() {
        return 'DeferredFragmentIdentifier(path=' + toString(this.p46_1) + ', label=' + this.q46_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.p46_1);
        result = imul(result, 31) + (this.q46_1 == null ? 0 : getStringHashCode(this.q46_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeferredFragmentIdentifier()))
          return false;
        var tmp0_other_with_cast = other instanceof DeferredFragmentIdentifier() ? other : THROW_CCE();
        if (!equals(this.p46_1, tmp0_other_with_cast.p46_1))
          return false;
        if (!(this.q46_1 == tmp0_other_with_cast.q46_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeferredFragmentIdentifier');
    DeferredFragmentIdentifierClass = $;
  }
  return DeferredFragmentIdentifierClass;
}
//region block: exports
export {
  DeferredFragmentIdentifier as DeferredFragmentIdentifieryfmj5mbsp1mh,
};
//endregion

//# sourceMappingURL=DeferredFragmentIdentifier.mjs.map
